<h2 class="step-title">{{ title }}</h2>
<ul>
  @for (button of buttonList; track button) {
    <li>
      <div>
        <button
          [ngClass]="['icon-button', 'has-shadow-small']"
          [ngStyle]="{'border' : button.borderStyle}"
          [attr.default]="button.default ? true : null"
          (click)="submit(button)">
          <div class="button-content">
            <div class="button-image"><img src="{{ buttonPath + 'new-' + button.imageName + fileType }}" alt=""></div>
            <div class="label"><div>{{ button.text }}</div></div>
          </div>
        </button>
      </div>
    </li>
  }
</ul>

@if (notPrimary) {
  <div class="reverse-stop" role="status">
    <p class="reverse-stop-title">A reverse mortgage is for the home you live in</p>
    <p>The home has to be your primary residence. For another property, a cash-out refinance or a home equity loan may fit better.</p>
    <a class="button is-large has-shadow-small" href="/communication/form-landing?type=home-equity-loan">See home equity options</a>
  </div>
}
